import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=7f5b58e5&scoped=true"
import script from "./productCenter.vue?vue&type=script&lang=js"
export * from "./productCenter.vue?vue&type=script&lang=js"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=7f5b58e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5b58e5",
  null
  
)

export default component.exports